import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Box, Boxes, ChevronsLeft, ChevronsRight, ChevronRight, Container, Settings, LayoutDashboard, Plus, UsersRound, Warehouse } from 'lucide-react';
import sidebarPort from '../assets/images/sidebar-port.jpg';
import { useAuth } from '../auth/AuthProvider';
import { canRead, canWrite, homePath } from '../auth/permissions';

const links = [
  ['/dashboard', LayoutDashboard, 'Dashboard', 'Dashboard'],
  ['/warehouses', Warehouse, 'Warehouses', 'Warehouse'],
  ['/customers', UsersRound, 'Customers', 'Customers'],
  ['/inventory', Boxes, 'Inventory', 'Inventory'],
  ['/container-planning', Container, 'Container Planning', 'ContainerPlanning'],
  ['/users', UsersRound, 'Users', 'Users'],
  ['/settings', Settings, 'Settings', null],
];

export default function Sidebar({ open, collapsed = false, onToggleCollapsed, onNavigate }) {
  const { user } = useAuth();
  const location = useLocation();
  const settingsSubpage = ['/packaging-types', '/units'].includes(location.pathname);
  const mainPageTarget = pathname => ({ pathname, search: location.pathname === pathname ? location.search : '' });
  const visibleLinks = links.filter(([, , , module]) => !module || canRead(user, module));
  return <aside className={`app-sidebar${open ? ' open' : ''}${collapsed ? ' collapsed' : ''}`} aria-label="Workspace">
    <div className="app-sidebar-bg" style={{ '--sidebar-image': `url(${sidebarPort})` }} />
    <div className="app-sidebar-wash" />
    <div className="app-sidebar-inner">
      <div className="app-sidebar-head">
        <NavLink className="app-brand" to={homePath(user)} onClick={onNavigate} aria-label="Import ERP home">
          <span className="app-brand-mark"><Box size={15} strokeWidth={2} /></span>
          <span className="app-brand-label">IMPORT ERP</span>
        </NavLink>
        <button className="app-sidebar-collapse" type="button" onClick={onToggleCollapsed}
          aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'} title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'} aria-pressed={collapsed}>
          {collapsed ? <ChevronsRight size={17} strokeWidth={2.2} /> : <ChevronsLeft size={17} strokeWidth={2.2} />}
        </button>
      </div>
      {canWrite(user, 'ContainerPlanning') && <NavLink className="app-new-container" to={mainPageTarget('/container-planning')} state={{ createContainerDraft: true }} onClick={onNavigate} aria-label="New Container" title={collapsed ? 'New Container' : undefined}><Plus size={13} /><span className="app-new-container-label">New Container</span></NavLink>}
      <nav className="app-nav" aria-label="Main">
        {visibleLinks.map(([to, Icon, label]) => (
          <NavLink key={to} to={mainPageTarget(to)} aria-label={label} title={collapsed ? label : undefined} className={({ isActive }) => `app-nav-link${isActive || (to === '/settings' && settingsSubpage) ? ' active' : ''}`} onClick={onNavigate}>
            {({ isActive }) => <><Icon size={15} strokeWidth={1.7} /><span className="app-nav-label">{label}</span>
              {(isActive || (to === '/settings' && settingsSubpage)) && <ChevronRight className="app-nav-current-icon" size={14} strokeWidth={2.2} aria-hidden="true" />}
            </>}
          </NavLink>
        ))}
      </nav>
    </div>
  </aside>;
}
